import React, { useEffect } from 'react'
import { useAppSelector, dispatch } from '@/redux/store'
import { makeStyles } from '@mui/styles'
import { DMS_UPLOAD_ALLOWED_EXTENSIONS, fetchAllowedMimetypes } from '@/redux/ducks/document/upload'
import { Tooltip } from '@mui/material'
import lang from '@/lang'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import InfoIcon from '@assets/images/icons/info-icon.svg'
import { isDmsUploadEnabled } from '@/redux/ducks/document/uploadHelpers'

import { ALLOWED_FILE_EXTENSIONS } from '@/modules/file/uploader'
import { uniq } from 'lodash'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  infoIcon: {
    zIndex: 9999,
  },
  infoIconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer',
    pointerEvents: 'auto',
  },
  tooltip: {
    fontSize: theme.fontSizes.tooltip,
  },
}))

const InfoTooltip = () => {
  const classes = useStyles()
  const dmsFileExtensions = useAppSelector((state) => state.document.upload.allowedMimetypes.flatMap(mt => (mt.extensions ?? []).map(ext => `.${ext}`)))

  const useDmsUpload = isDmsUploadEnabled()
  let allowedExtensions = ALLOWED_FILE_EXTENSIONS

  if (useDmsUpload) {
    allowedExtensions = dmsFileExtensions?.length ? dmsFileExtensions : DMS_UPLOAD_ALLOWED_EXTENSIONS
  }

  const allowedExtensionsString = uniq(allowedExtensions.sort()).join(', ')

  useEffect(() => {
    if (useDmsUpload) {
      dispatch(fetchAllowedMimetypes())
    }
  }, [])

  return useDmsUpload
    ? (
      <Tooltip classes={{ tooltip: classes.tooltip }} title={allowedExtensionsString}>
        <div className={classes.infoIconWrapper}>
          {lang.fileUploadChooser.acceptedFileTypes}
          <SVGIcon className={classes.infoIcon} svg={InfoIcon} height="16px" width="16px" fill={'#fff'} />
        </div>
      </Tooltip>
    )
    : (
      <>
        {lang.fileUploadChooser.acceptedFileTypes + ': ' + allowedExtensionsString}
      </>
    )
}

export default InfoTooltip
